import { TURKIYE_ENABLED } from "../config/features";

export type CountryCodeOption = {
  code: string;
  label: string;
};

// Behind the Türkiye gate: the dial code is only offered once Türkiye is live.
const TURKEY_COUNTRY_CODE: CountryCodeOption = { code: "+90", label: "🇹🇷  Turkey (+90)" };

export const COUNTRY_CODES: CountryCodeOption[] = [
  { code: "+61", label: "🇦🇺  Australia (+61)" },
  { code: "+1-CA", label: "🇨🇦  Canada (+1)" },
  { code: "+1-US", label: "🇺🇸  USA (+1)" },
  { code: "+44", label: "🇬🇧  United Kingdom (+44)" },
  { code: "+64", label: "🇳🇿  New Zealand (+64)" },
  ...(TURKIYE_ENABLED ? [TURKEY_COUNTRY_CODE] : []),
];

export const PHONE_PLACEHOLDERS: Record<string, string> = {
  "+61": "400 000 000",
  "+1-CA": "416 555 1234",
  "+1-US": "555 123 4567",
  "+44": "07123 456789",
  "+64": "021 123 4567",
  "+90": "532 123 45 67",
};

export const DEFAULT_COUNTRY_CODE = "+61";

export const getDialCode = (code: string) =>
  code.replace("-CA", "").replace("-US", "");

export const getPhonePlaceholder = (countryCode: string) =>
  PHONE_PLACEHOLDERS[countryCode] || "Phone number";
